var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "18px",
    viewBox: "0 0 72 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "AvenirNext-Medium, Avenir Next",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-159.000000, -68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 13
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13,
    fill: "#289FF1"
  }, "trade"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.733,
    y: 13,
    fill: "#3EAA29"
  }, "name")), /*#__PURE__*/React.createElement("text", {
    fontSize: 6,
    "line-spacing": 6,
    letterSpacing: -2,
    fill: "#3EAA29"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    y: 13
  }, "\u2122")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradename);
export default __webpack_public_path__ + "static/media/tradename.bc2cfd26.svg";
export { ForwardRef as ReactComponent };